import { Stack, Typography } from '@mui/material';

import routes from '@routes';
import { Page } from '@common/ui/Page';
import Markdown from '@common/ui/Markdown';
import GenerateTokenForm from '@PersonalApiTokens/organisms/GenerateTokenForm';

export default function AddPersonalApiTokenPage() {
  const breadcrumbs = [{ label: 'Personal API Tokens', href: routes.PersonalApiTokens.path }];

  return (
    <Page title="Add API Token" breadcrumbs={breadcrumbs} contentNarrowed contentPadded>
      <Stack spacing={3}>
        <div>
          <Typography variant="subtitle1" component="h2">
            Add Personal API Token
          </Typography>
          <Typography variant="body2" component="div" color="text.muted">
            <Markdown>
              Apono Personal API Tokens can be used for integration with external tools and working with the Apono API.
              Please specify a descriptive name to be used for this personal API token. Tokens are specific to users.
            </Markdown>
          </Typography>
        </div>
        <GenerateTokenForm />
      </Stack>
    </Page>
  );
}
